export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9451.cb6c23f6.jpg";